<template>
  <div
    :class="[
            snapshot.context.sidebarMinimized ? 'w-[70px]' : 'w-[264px]',
            'z-50 flex h-screen transform flex-col bg-sidebar',
        ]"
    style="transition: width 0.3s ease-in-out; background-color: #1B1B28;"
  >
    <!-- Top of the sidebar-->
    <div class="border-b border-gray-700/50 px-4 py-6" style="background-color: #161622">
      <SidebarLogo
        :current-website="currentWebsite"
        :is-minimized="snapshot.context.sidebarMinimized"
      />

      <SidebarWebsiteSelector />
    </div>

    <!-- Mid of the sidebar -->
    <div class="flex flex-grow flex-col overflow-y-auto px-4 pt-4">
      <SidebarMenuItems :currentSidebarConfig="currentSidebarConfig" :snapshot="snapshot" />
    </div>

    <!-- Bottom of the sidebar -->
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useMachine } from '@xstate/vue'

// Config
import { mainSidebarConfig } from '@/shared/config/mainSidebarConfig'
import { websiteSidebarConfig } from '@/shared/config/websiteSidebarConfig'

// Subcomponents
import SidebarLogo from './SidebarLogo.vue'
import SidebarWebsiteSelector from './SidebarWebsiteSelector.vue'
import SidebarMenuItems from './SidebarMenuItems.vue'
import { sidebarMachine } from './stateMachine'

export default defineComponent({
    components: {
        SidebarLogo,
        SidebarWebsiteSelector,
        SidebarMenuItems
    },
    setup() {
        const { currentRoute } = useRouter()
        const { snapshot, send } = useMachine(sidebarMachine)

        const currentWebsite = {"websiteId":"1"}

        const currentSidebarConfig: any = computed(() => {
            return currentRoute.value.meta.sidebar === 'main' ? mainSidebarConfig : websiteSidebarConfig
        })

        return {
            snapshot,
            send,
            currentWebsite,
            currentSidebarConfig
        }
    },
})
</script>
